import React, { Component } from 'react';
import './ConfirmData.css';
import logoblue from '../../image/logoblue.png'
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar/Navbar'
import rightlg from '../../image/rightlg.png'
import Footer from '../Components/Footer/Footer'

class ConfirmData extends Component {

    render() {
        document.title ="Kayn | Confirm Email"; 
        document.getElementsByTagName("META")[1].content="Kayn Confirm Email";
        document.documentElement.lang = 'en';
        return (
            <div className="AppEN ConfirmData">
                <Navbar />
                <div className='container'>
                            <div class="mx-auto col-6 text-center alert alert-danger" role="alert">
                                <p className="fontsize6  m-0">This service has been stopped to continue accessing pages using this account</p>
                                <p className="fontsize6  m-0">E-mail:user@user.com</p>
                                <p className="fontsize6 m-0">password:123456789</p>
                                <p className="fontsize6  m-0">to sign in as a admin <Link to="/admin/Signin">Click here</Link></p>
                                <p className="fontsize6  m-0">to sign in as a Client <Link to="/admin/Signin">Click here</Link></p>
                            </div>
                    <div className="Sign  row">
                        <div className="logoform col-6 d-flex align-content-end flex-wrap">
                            <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/"><img className="logo" src={logoblue} alt="kayn" /></Link>       </div>
                            <p className="fontsize2 text-center mb-5 col-12">Your package...your way</p>
                        </div>
                        <div className="col-md-6 form text-center p-lg-5  ">
                            
                        <div className=" mx-auto  textconfirm">
                        
                        <img className="mt-2 warningimg" src={rightlg} alt="rightlg" />
                        <p className="fontsize9 font-weight-bold  pt-lg-4">Email Sent</p>
                        <p className="fontsize11 text-muted px-lg-5"> Vertification link sent to your mail.Please check your Inbox to vertify your Account</p>

                        </div>

                        </div>
                    </div>
                </div>
                <Footer/>

            </div>
        )
    }
}
export default ConfirmData;